import React, { ReactNode } from "react";

import { ILogger } from "./ILogger";
import { LoggerContext } from "./LoggerContext";

interface IRouterContextProviderProps {
    logger: ILogger;
    children: ReactNode;
}

export function LoggerContextProvider(props: IRouterContextProviderProps) {
    const { logger, children } = props;
    return (
        <LoggerContext.Provider value={logger}>
            {children}
        </LoggerContext.Provider>
    );
}
